import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { notasService } from '../services/notas.service';
import { useAuthStore } from '../store/useAuthStore';
import { useWorkspaceStore } from '../store/useWorkspaceStore';

export const useNotasQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['notas', activeWorkspaceId],
    queryFn: notasService.getNotas,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useCrearNotaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: notasService.crearNota,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notas'] });
    },
  });
};

export const useEliminarNotaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: notasService.eliminarNota,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['notas'] });
    },
  });
};
